<div *ngIf="badgeTheme === '1'"
    class="badge-theme-{{badgeTheme}} user-avatar-outer d-flex align-items-center justify-content-center rounded-circle"
    [style.width]="userBadgeCustomization.outerBoxWidth" 
    [style.height]="userBadgeCustomization.outerBoxHeight"
>
    <div HJSuppress class="user-avatar d-flex align-items-center justify-content-center rounded-circle p-1 fw-bold"
        [style.width]="userBadgeCustomization.innerBoxWidth" 
        [style.height]="userBadgeCustomization.innerBoxHeight"
        [style.fontSize]="fontSize"
    >
        {{displayedInitials}}
    </div>
</div>

<div *ngIf="badgeTheme === '2'" HJSuppress
    class="badge-theme-{{badgeTheme}} user-avatar d-flex align-items-center justify-content-center rounded-circle fw-semibold"
    [style.width.px]="width" 
    [style.height.px]="height"
    [style.fontSize]="fontSize"
>
    {{displayedInitials}}
</div>